import { tzPublicAxios } from 'api/axios';
import { InternationalEventResponse, InternationalEventsResponse } from 'api/responseTypes';

// Base URL ends with `/consumers`, so paths start at `/ticket-zone/...` (as in api/concerts).
const BASE = '/ticket-zone/home';

/** Full visible set (no filter/pagination params). */
export const getInternationalEvents = async () =>
  (await tzPublicAxios.get<InternationalEventsResponse>(`${BASE}/get-international-events`)).data;

/** Single event by id; 404 when not on sale/published. */
export const getInternationalEventDetail = async (id: number | string) =>
  (
    await tzPublicAxios.get<InternationalEventResponse>(
      `${BASE}/get-international-event-detail/${id}`,
    )
  ).data;
